var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentChosen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 198.535,
    viewBox: "0 0 160 198.535",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-2{fill:none;stroke:#606060;stroke-width:2.835px}.cls-2{fill:#13647b}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Student_Chosen",
    transform: "translate(-866 -303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    transform: "translate(479.779 258.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    d: "M469.591 206.128h-34.808c-2.4 0-3.1.71-3.118 3.121-.022 3.742.371 4.139 4.094 4.139h11.248v22.7c-1.142 0-2.257-.018-3.371 0a2.361 2.361 0 0 0-2.608 2.085 2.312 2.312 0 0 0 0 .5c-.018.809 0 1.621 0 2.609h-1.19l-23.022-.014c-1.723 0-2.089-.377-2.09-2.143V134.24c0-1.862.553-2.422 2.433-2.422q49.243-.007 98.488 0",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2213",
    d: "M461.582 146.694h-.005c0-1.976.022-3.951-.006-5.925a2.328 2.328 0 0 0-2.06-2.568 2.387 2.387 0 0 0-.554 0q-4.705-.022-9.412 0a2.376 2.376 0 0 0-2.646 2.666q-.033 5.808 0 11.618a2.421 2.421 0 0 0 2.752 2.7q4.59.021 9.179 0c1.888-.009 2.738-.882 2.752-2.8.011-1.896 0-3.794 0-5.691z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2214",
    d: "M461.582 167.578h.013c0-1.936.009-3.872 0-5.808-.01-1.883-.9-2.776-2.779-2.784q-4.589-.015-9.178 0a2.411 2.411 0 0 0-2.744 2.7q-.035 5.751 0 11.5c.01 1.916.868 2.766 2.773 2.776q4.589.025 9.178 0a2.4 2.4 0 0 0 2.731-2.7c.025-1.893.008-3.791.008-5.689z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    d: "M422.582 191.435c0 1.976-.014 3.951.005 5.927a2.311 2.311 0 0 0 2.582 2.589q4.707.03 9.414 0a2.353 2.353 0 0 0 2.666-2.636q.025-5.866 0-11.737a2.437 2.437 0 0 0-2.706-2.638q-4.648 0-9.3.027a2.4 2.4 0 0 0-2.664 2.1 2.362 2.362 0 0 0 0 .551c0 1.938.01 3.877.011 5.813z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    d: "M461.576 191.472h-.006c0-1.86.009-3.719 0-5.577-.014-2.069-.822-2.928-2.865-2.943q-4.585-.033-9.17.024a2.353 2.353 0 0 0-2.636 2.678q-.034 5.811 0 11.62a2.358 2.358 0 0 0 2.638 2.679q4.705.034 9.412 0c1.774-.014 2.611-.876 2.63-2.67.026-1.937.009-3.875.009-5.811z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    d: "M437.26 226.4c0-1.976.022-3.951-.006-5.927a2.326 2.326 0 0 0-2.536-2.533q-4.822-.03-9.645.005a2.282 2.282 0 0 0-2.474 2.071 2.217 2.217 0 0 0 0 .4q-.041 5.985 0 11.969a2.3 2.3 0 0 0 2.535 2.529q4.764.034 9.529 0a2.345 2.345 0 0 0 2.6-2.062 2.379 2.379 0 0 0 0-.527c.01-1.971-.003-3.946-.003-5.925z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    d: "M422.589 167.446c0 1.9-.006 3.8 0 5.7.009 1.981.844 2.821 2.831 2.827 3.06.009 6.12 0 9.181 0a2.351 2.351 0 0 0 2.655-2.64q.025-5.81 0-11.621a2.4 2.4 0 0 0-2.711-2.716q-4.648-.021-9.3 0a2.366 2.366 0 0 0-2.657 2.643c-.012 1.932.002 3.869.001 5.807z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    d: "M422.592 146.667c0 1.974-.014 3.95 0 5.925a2.336 2.336 0 0 0 2.063 2.581 2.312 2.312 0 0 0 .424.008q4.822.051 9.643 0a2.343 2.343 0 0 0 2.53-2.554q.03-5.927 0-11.852a2.321 2.321 0 0 0-2.608-2.567q-4.707-.027-9.411 0a2.337 2.337 0 0 0-2.642 2.65c-.014 1.935 0 3.871 0 5.808z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2024",
    d: "M466.366 126.7h-43.358c-.31 0-.673.1-.918-.025-.427-.221-1.043-.544-1.1-.9a1.447 1.447 0 0 1 .788-1.151c1.607-.554 3.265-.964 4.907-1.42q18.8-5.23 37.592-10.471a7.593 7.593 0 0 1 4.224 0q20.86 5.838 41.731 11.63c.261.073.6.071.768.237.35.34.877.8.837 1.157s-.654.7-1.085.914a2.55 2.55 0 0 1-1.033.029z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2025",
    d: "M466.346 131.488h-52.9a11.124 11.124 0 0 1-1.278-.028 2.147 2.147 0 0 1-1.93-2 2.123 2.123 0 0 1 1.653-2.338 5.55 5.55 0 0 1 1.267-.1q53.249-.006 106.5.017a4.272 4.272 0 0 1 2.073.516 1.908 1.908 0 0 1 .8 2.25 2.093 2.093 0 0 1-1.772 1.633 7.451 7.451 0 0 1-1.276.043z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2043",
    fill: "#dcdcdc",
    stroke: "#606060",
    strokeWidth: "2.835px",
    d: "M485.5 96.5c0 2 .116 5.28 0 7-.071 1.023.409.059 0 1-.731 1.663-2.185 3.372-3 5-.707 1.411-.605 2.988 1 3 2.015.014 1.888.176 3.9.162 1.728-.009 2.13-.7 1.329-2.276-.929-1.83-1.881-3.649-2.791-5.49a3.165 3.165 0 0 1-.367-1.31c-.036-2.324-.052-4.651.017-6.973a1.858 1.858 0 0 1 .7-1.271c1.424-1 2.946-1.866 4.373-2.865a1.222 1.222 0 0 0-.242-2.344q-11.511-4.845-23.066-9.586a2.557 2.557 0 0 0-1.755-.006q-11.5 4.716-22.956 9.543c-.472.2-1.116.737-1.116 1.117a2.081 2.081 0 0 0 .935 1.4q5.049 3.32 10.185 6.507a1.909 1.909 0 0 1 1.063 1.945c-.073 1.508-.042 3.023 0 4.532.06 2.13 2.076 3.35 3.8 1.982a26.554 26.554 0 0 1 4.991-2.067c2.939-.741 3.987-.332 7 0a12.022 12.022 0 0 1 5.84 1.991c.822.546 1.62.96 2.575.414a2.633 2.633 0 0 0 1.3-2.441c.015-1.588-.011-3.177.021-4.766.006-.357.066-.871.3-1.039 1.13-.808 4.578-2.268 5.964-3.159z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    d: "M515.966 131.818c1.88 0 2.433.56 2.433 2.422v104.884c0 1.766-.367 2.143-2.09 2.143l-23.022.014H492.1c0-.988.018-1.8 0-2.609a2.31 2.31 0 0 0 0-.5 2.361 2.361 0 0 0-2.608-2.085c-1.114-.018-2.229 0-3.371 0v-22.7h11.248c3.723 0 4.116-.4 4.094-4.139-.018-2.411-.718-3.121-3.118-3.121h-30.814",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    d: "M471.54 152.1c.014 1.918.864 2.791 2.752 2.8q4.589.021 9.179 0a2.424 2.424 0 0 0 2.752-2.7q.033-5.81 0-11.618a2.376 2.376 0 0 0-2.646-2.666q-4.707-.024-9.412 0a2.326 2.326 0 0 0-2.614 2.563c-.028 1.974-.006 3.949-.006 5.925h-.005c0 1.896-.011 3.796 0 5.696z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    d: "M471.538 167.286c0 1.9-.017 3.8.008 5.689a2.4 2.4 0 0 0 2.731 2.7q4.59.02 9.178-.005c1.9-.01 2.763-.86 2.773-2.776q.035-5.749 0-11.5a2.442 2.442 0 0 0-.005-.667 2.412 2.412 0 0 0-2.739-2.033q-4.59-.015-9.178 0c-1.879.008-2.769.9-2.779 2.784-.009 1.936 0 3.872 0 5.808h.011z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    d: "M510.533 191.143c0-1.936.015-3.875.011-5.813a2.427 2.427 0 0 0 0-.552 2.4 2.4 0 0 0-2.664-2.1q-4.651-.027-9.3-.027a2.432 2.432 0 0 0-2.706 2.638q-.025 5.87 0 11.737a2.353 2.353 0 0 0 2.666 2.636q4.707.028 9.414 0a2.29 2.29 0 0 0 .579 0 2.314 2.314 0 0 0 2-2.588c.019-1.976.005-3.951.005-5.927z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    d: "M471.539 191.18c0 1.936-.017 3.874.009 5.811.019 1.794.856 2.656 2.63 2.67q4.707.035 9.412 0a2.391 2.391 0 0 0 .638 0 2.361 2.361 0 0 0 2-2.674q.03-5.81-.005-11.62a2.353 2.353 0 0 0-2.636-2.678q-4.586-.059-9.17-.024c-2.043.015-2.851.874-2.865 2.943-.009 1.858 0 3.717 0 5.577h-.013z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    d: "M495.859 232.035a2.372 2.372 0 0 0 0 .526 2.346 2.346 0 0 0 2.6 2.063q4.765.035 9.529 0a2.3 2.3 0 0 0 2.535-2.529q.04-5.985 0-11.969a2.325 2.325 0 0 0 0-.4 2.281 2.281 0 0 0-2.474-2.07q-4.822-.036-9.645-.005a2.326 2.326 0 0 0-2.536 2.533c-.028 1.976-.006 3.951-.006 5.927s-.013 3.951-.003 5.924z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    d: "M510.534 161.342a2.366 2.366 0 0 0-2.657-2.643q-4.652-.021-9.3 0a2.4 2.4 0 0 0-2.711 2.716q-.025 5.811 0 11.621a2.352 2.352 0 0 0 2.655 2.64c3.061 0 6.121.009 9.181 0 1.987-.006 2.822-.846 2.831-2.827.006-1.9 0-3.795 0-5.695-.001-1.938.013-3.875.001-5.812z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    d: "M510.53 146.374c0-1.937.015-3.873 0-5.808a2.36 2.36 0 0 0 0-.666 2.336 2.336 0 0 0-2.643-1.984q-4.7-.027-9.411 0a2.317 2.317 0 0 0-2.608 2.567q-.03 5.925 0 11.852a2.31 2.31 0 0 0 0 .416 2.343 2.343 0 0 0 2.532 2.138q4.821.049 9.643 0a2.313 2.313 0 0 0 .424-.009 2.336 2.336 0 0 0 2.063-2.58c.014-1.975 0-3.951 0-5.925z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    d: "M452.5 99.5s13-10 27 1",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_65",
    d: "M0 0L54.681 0.006",
    className: "cls-1",
    transform: "translate(440.591 241.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_319",
    fill: "#13647b",
    stroke: "#606060",
    strokeWidth: "2.719px",
    d: "M0 0H28V23H0z",
    transform: "translate(452.591 213.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_66",
    fill: "none",
    stroke: "#606060",
    strokeWidth: "2.719px",
    d: "M0 0L0 23",
    transform: "translate(466.591 213.5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_341",
    fill: "none",
    d: "M0 0H160V198H0z",
    transform: "translate(866 303)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentChosen);
export default __webpack_public_path__ + "static/media/student-chosen.028b51e7ed205e1c62f2bd5180f26734.svg";
export { ForwardRef as ReactComponent };